import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="tw-min-h-screen tw-bg-white tw-flex tw-items-center tw-justify-center tw-p-4">
      <div className="tw-max-w-2xl tw-w-full tw-text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="tw-relative tw-mb-8">
            <h1 className="tw-text-[180px] tw-font-bold tw-text-gray-100">
              404
            </h1>
            <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
              <motion.div
                animate={{
                  rotate: [0, 10, -10, 10, 0],
                  scale: [1, 1.1, 1],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  repeatType: 'reverse',
                }}
              >
                <span className="tw-text-4xl">🤔</span>
              </motion.div>
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            <h2 className="tw-text-3xl tw-font-semibold tw-text-gray-900 tw-mb-4">
              Page not found
            </h2>
            <p className="tw-text-gray-600 tw-mb-8 tw-text-lg">
              We couldn't find the page you're looking for. Let's get you back
              on track.
            </p>

            <div className="tw-flex tw-flex-col tw-gap-4 tw-items-center tw-justify-center sm:tw-flex-row">
              <button
                onClick={() => navigate(-1)}
                className="tw-px-6 tw-py-3 tw-text-gray-700 tw-bg-gray-100 tw-rounded-lg tw-font-medium 
                         hover:tw-bg-gray-200 tw-transition-colors tw-duration-200 tw-w-full sm:tw-w-auto"
              >
                Go Back
              </button>
              <button
                onClick={() => navigate('/')}
                className="tw-px-6 tw-py-3 tw-bg-blue-500 tw-text-white tw-rounded-lg tw-font-medium
                         hover:tw-bg-blue-600 tw-transition-colors tw-duration-200 tw-w-full sm:tw-w-auto"
              >
                Go Home
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="tw-mt-12 tw-p-6 tw-bg-gray-50 tw-rounded-2xl"
          >
            <h3 className="tw-text-lg tw-font-medium tw-text-gray-900 tw-mb-4">
              You might want to check out
            </h3>
            <div className="tw-grid tw-gap-4 tw-text-left">
              {[
                { text: 'Bookings', path: '/bookings' },
                { text: 'Documents', path: '/cms' },
              ].map((link, index) => (
                <button
                  key={index}
                  onClick={() => navigate(link.path)}
                  className="tw-p-4 tw-bg-white tw-rounded-lg tw-shadow-sm hover:tw-shadow-md 
                           tw-transition-shadow tw-duration-200 tw-flex tw-items-center tw-justify-between"
                >
                  <span className="tw-text-gray-700">{link.text}</span>
                  <svg
                    className="tw-w-5 tw-h-5 tw-text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
